import { render, staticRenderFns } from "./formRencanaAksi.vue?vue&type=template&id=3da536ae&scoped=true&"
import script from "./formRencanaAksi.vue?vue&type=script&lang=js&"
export * from "./formRencanaAksi.vue?vue&type=script&lang=js&"
import style0 from "./formRencanaAksi.vue?vue&type=style&index=0&id=3da536ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da536ae",
  null
  
)

export default component.exports